import React, { useState } from 'react';
import { SiteStatusDto } from '../Requests/useGetSitesStatus';
import { SiteStatusToIndicator, SiteStatusToDisplay, SortSitesStatuses } from '../Dashboard/SitesStatusWidget';
import useInterval from '../Common/useInterval';
import { CenteredSpinner } from '../Common/CenteredSpinner';
import { useKaEmployee } from '../UserAccess/useKaEmployee';
import useQuery, { QueryOptions } from '../Common/useQuery';


const useGetEmployeeSitesStatus = (options?: QueryOptions<SiteStatusDto[]>) => {
  const kahlerUser = useKaEmployee();

  return useQuery<SiteStatusDto[]>({
    headers: kahlerUser.fetchHeaders,
    path: `/employeeApi/businesses/${kahlerUser.selectedBusiness?.id!}/sitesStatus`
  },
    options);
}

const EmployeeSitesStatusPage = () => {
  const refreshTimeMs = 30_000;
  const [data, setData] = useState<SiteStatusDto[] | null>(null);

  const getSitesStatus = useGetEmployeeSitesStatus({
    onSuccess: (resp) => setData(SortSitesStatuses(resp))
  });

  useInterval(() => getSitesStatus.query(), refreshTimeMs, false);

  if (data === null && getSitesStatus.isLoading) return <CenteredSpinner />
  if (getSitesStatus.isError) return <h3>{getSitesStatus.error?.message}</h3>
  if (data?.length === 0 ) return <h3>No Site Status Available</h3>

  return <>
  <div className="ms-n2 pb-3">
    <div className="my-auto text-nowrap" style={{ fontSize: 20 }}>
      Site Connection Status
    </div>
  </div>
  <div className="w-100 vh-50 d-flex justify-content-between">
    <table className="table table-borderless preserve-whitespace">
      <thead>
        <tr>
          <th>Site</th>
          <th>Status</th>
          <th className="col-2">Pending Notifications</th>
          <th>{data?.some(s => s.error !== undefined) ? "Message" : ""}</th>
        </tr>
      </thead>
      <tbody>
        {data?.map((siteStatus) => <tr key={siteStatus.siteName} className="my-1">
          <td>
            <i className={`mx-2
              ${SiteStatusToIndicator(siteStatus)}`}>
            </i>
            {siteStatus.siteName}
            {(siteStatus.siteKey || siteStatus.pcName) && (
              <div className="small text-muted ms-2 mt-1 mb-2">
                {siteStatus.siteKey && <div>Site Key: {siteStatus.siteKey}</div>}
                {siteStatus.pcName && <div>PC Name: {siteStatus.pcName}</div>}
              </div>
            )}
          </td>
          <td>{SiteStatusToDisplay(siteStatus)}</td>
          <td>{siteStatus.pendingNotificationCount}</td>
          <td className="preserve-whitespace">{siteStatus.error}</td>
        </tr>)} 
      </tbody>
    </table>
  </div>
</>}

export { EmployeeSitesStatusPage };